module.exports = __webpack_public_path__ + "img/754d291.jpg";